import { render, staticRenderFns } from "./ClientsActivity.vue?vue&type=template&id=84d1d7e6&"
import script from "./ClientsActivity.vue?vue&type=script&lang=js&"
export * from "./ClientsActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports